/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  PostUserRequestsUploadDocument201,
  PostUserRequestsUploadDocument400,
  PostUserRequestsUploadDocumentMutationRequest,
  PostUserRequestsUploadDocumentMutationResponse,
} from '../entities/PostUserRequestsUploadDocument'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { z } from 'zod'

/**
 * @description Ссылка на файл
 */
export const postUserRequestsUploadDocument201Schema = z.string() as unknown as ToZod<PostUserRequestsUploadDocument201>

/**
 * @description Bad Request
 */
export const postUserRequestsUploadDocument400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<PostUserRequestsUploadDocument400>

export const postUserRequestsUploadDocumentMutationRequestSchema = z.object({
  file: z.instanceof(File).describe('Файл'),
}) as unknown as ToZod<PostUserRequestsUploadDocumentMutationRequest>

export const postUserRequestsUploadDocumentMutationResponseSchema = z.lazy(
  () => postUserRequestsUploadDocument201Schema,
) as unknown as ToZod<PostUserRequestsUploadDocumentMutationResponse>